import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'
import { EliminarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdGrupoContableInventarioFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  gruposContablesInventarios,
  actualizarGruposContablesInventarios
}) => {
  const [mostrarSeleccionarCuentaModal, setMostrarSeleccionarCuentaModal] = React.useState(false)
  const [mostrarEliminarCuentaModal, setMostrarEliminarCuentaModal] = React.useState(false)
  const [dataGrupoContable, setDataGrupoContable] = React.useState(null)

  React.useEffect(() => {
    if (gruposContablesInventarios.length === 1) {
      values.cuentaContableInventario = gruposContablesInventarios[0]._id
      setValues(values)
    }
  }, [gruposContablesInventarios, values, setValues])

  const onSuccess = React.useCallback(async () => {
    actualizarGruposContablesInventarios()
    setMostrarSeleccionarCuentaModal(false)
  }, [actualizarGruposContablesInventarios])

  const clickEliminarGrupoContable = React.useCallback(() => {
    const found = gruposContablesInventarios.find(x => x._id === values.cuentaContableInventario)
    if (!found) return
    TablaPersonalizadaService.getAsEdicion(found.id).then(({ data }) => {
      setDataGrupoContable(data)
      setMostrarEliminarCuentaModal(true)
    })
  }, [values, gruposContablesInventarios])

  return (
    <>
      <Form.Group>
        <Form.Label text='INVENTARIOS' htmlFor='select-gContablesInventario' sm={2} md={3} lg={2} alignRightAt='sm' />
        <Col sm={10} md={9} lg={10}>
          <Form.InputGroup>
            <Field name='cuentaContableInventario'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  id='select-gContablesInventario'
                >
                  <option value=''>Seleccionar</option>
                  {gruposContablesInventarios &&
                    gruposContablesInventarios.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarSeleccionarCuentaModal(true)}>+</Button>
              <Button className='bg-danger border border-danger' onClick={() => clickEliminarGrupoContable()}>
                -
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarSeleccionarCuentaModal && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarSeleccionarCuentaModal(false)}
          show={mostrarSeleccionarCuentaModal}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLEINVENTARIO}
        />
      )}
      {mostrarEliminarCuentaModal && (
        <EliminarTablaPersonalizadaModal
          handleClose={e => setMostrarEliminarCuentaModal(false)}
          show={mostrarEliminarCuentaModal}
          modalData={dataGrupoContable}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLEINVENTARIO}
        />
      )}
    </>
  )
}

export default React.memo(IdGrupoContableInventarioFormGroup)
